import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'
import PublicEventsDispatcher from 'common/services/PublicEventsDispatcher'

import './style.css.scss'

const { EventTypes, dispatch: dispatchPublicEvent } = PublicEventsDispatcher()

const Items = (props) => {
  const { hasItems, selectedCategoryId, children } = props
  const hasContent = hasItems && selectedCategoryId

  useEffect(() => {
    dispatchPublicEvent(EventTypes.itemsContentMounted)
  }, [])

  return (
    <section className={`${LIVE_BOARD_CLASSNAMES.items} ${hasContent ? '' : 'empty-content'}`}>
      { hasContent && (
        <div className="items-view-content">
          { children }
        </div>
      )}
    </section>
  )
}

Items.propTypes = {
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  hasItems: PropTypes.bool.isRequired
}

export default Items
